import Request from './request'

const Server_Group  = {
  getServersGroup (callback) {
    Request.get('server-group/index').then(callback).catch(this.bad_answer)
  },
  createServerGroup (params, callback) {
    return Request.post('server-group/create', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  deleteServerGroup (id, callback) {
    Request.delete('server-group/delete/' + id).then(callback).catch(this.bad_answer)
  },
  updateServerGroup (id, params, callback) {
    return Request.post('server-group/update/' + id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  }
}

export default Server_Group
